import { useMemo, useState } from "react";

export default function usePagination<T>() {
  const [hasNextPage, setHasNextPage] = useState(false);
  const [page, setPage] = useState(0);
  const [resultsByPage, setResultsByPage] = useState<{ [page: number]: T[] }>(
    {},
  );
  const [totalPages, setTotalPages] = useState(0);

  function loadMore() {
    if (hasNextPage) setPage(page + 1);
  }

  function reset() {
    setHasNextPage(false);
    setPage(0);
    setResultsByPage({});
    setTotalPages(0);
  }

  const combinedPageResults = useMemo(
    () =>
      Object.values(resultsByPage).reduce(
        (acc, val) => [...acc, ...val],
        [] as T[],
      ),
    [resultsByPage],
  );

  return {
    combinedPageResults,
    currentPageResults: resultsByPage[page],
    hasNextPage,
    loadMore,
    page,
    reset,
    resultsByPage,
    setPage,
    totalPages,
    setHasNextPage,
    setResultsByPage,
    setTotalPages,
  };
}
